import ApiService from './ApiService'

const baseURL = process.env.VUE_APP_NOTIFICATIONS_URL;

const baseUserNotificationsURL = `${baseURL}/users/`
const notificationsURL = '/notifications'
const baseNotificationsURL = `${baseURL}${notificationsURL}`

export const Notifications = {
    all: () => {
        return new Promise((resolve, reject) => {
            ApiService.query(`${baseNotificationsURL}`)
            .then(response => resolve(response.data.data))
            .catch(errors => reject(errors))
        })
    }
}

export const UserNotifications = {
    get: (userId) => {
        return new Promise((resolve, reject) => {
          ApiService.query(`${baseUserNotificationsURL}${userId}${notificationsURL}`)
          .then(response => resolve(response.data.data))
          .catch(errors => reject(errors))
        })
    },
    update: (userId, data) => {
        return new Promise((resolve, reject) => {
            ApiService.put(`${baseUserNotificationsURL}${userId}${notificationsURL}`, data)
            .then(response => {
            resolve(response.data.data)
            })
            .catch(errors => reject(errors))
        })
    }
}